import _ from 'underscore';

import Levenshtein from 'levenshtein';

import PageView from '../../base/views/page';

import ContactList from '../collections/contact';


const Contact = Marionette.LayoutView.extend({
  tagName: 'option',
  template: require('../templates/contact.html'),
  attributes() {
    return {
      value: this.model.id,
      className: this.getOption('className'),
      selected: this.getOption('selected')
    };
  }
});


const Transaction = Marionette.CompositeView.extend({
  tagName: 'tr',
  template: require('../templates/item.html'),
  childView: Contact,
  childViewContainer: '.match select',

  childViewOptions(model, index) {
    const import_model = this.getOption('import_model');
    const query = this.getOption('queryModel');

    if (!query.get('description') && !model.id) {
      return {
        selected: true
      };
    }

    const epayment = import_model.get('epayments').findWhere({
      contact: model.id,
      transaction: this.model.id
    });
    var isSelected = false;

    if (epayment || (!epayment && !index)) {
      isSelected = true;
    }
    return {
      selected: isSelected
    };
  },

  ui: {
    contact: '.match select',
    costcentre: '.costcentre_match select'
  },

  triggers: {
    'change @ui.contact': 'change:contact',
    'change @ui.costcentre': 'change:contact'
  },

  templateHelpers() {
    return {
      highlight: this.warningClass(),
      transaction_type_name: this._getTransactionTypeName()
    };
  },

  _getTransactionTypeName() {
    const transaction_type = this.model.get('transaction_type');
    const _type = this.getOption('transaction_types').findWhere({
      transaction_type
    });
    return _.isUndefined(_type) ? '' : _type.get('transaction_type_name');
  },

  warningClass() {
    if (!this.getOption('queryModel').get('description')
        || this.model.get('matched_by_id')) {
      return;
    }

    var nameMatches = true;
    var multipleMatches = false;
    const mostLikelyContact = this.collection.models[0];

    if (this.collection.length > 1) {
      nameMatches = this._compareContacts(mostLikelyContact, this.model);
    }

    if (nameMatches && this.collection.length > 2) {
      const nextContact = this.collection.models[1];
      multipleMatches = this._compareContacts(mostLikelyContact, nextContact);
    }

    if (multipleMatches || !nameMatches) {
      return 'warning-highlight';
    }
  },

  initialize() {
    if (!this.collection.length || this.collection.at(0).id) {
      this.collection.add({
        title: '-- Don\'t Import --', id: '', distance: 999
      });
    }

    const name = this._joinNames(this.model);

    this.collection.each(function (contact) {
      if (contact.get('title')) {
        return;
      }

      const cname = this._joinNames(contact);

      const lev = new Levenshtein(name, cname);
      contact.set('distance', lev.distance);
    }, this);

    this.collection.sort();
  },

  onRender() {
    this.setFirstMatchedContact();
    this.setTransactionCostcentre();
    this.setDefaultAccount();
    this.onChangeContact();
  },

  setDefaultAccount() {
    const costcentreId = $('.costcentre-hook select').val();
    const costcentreName = $(
      '.costcentre-hook select option[value="' + costcentreId + '"]').text().trim()

    if (costcentreId) {
      this.ui.costcentre.find('option[value=""]').text(costcentreName);
    } else {
      this.ui.costcentre.find('option[value=""]').text('-- Default Account --');
    }
  },

  setTransactionCostcentre() {
    this.ui.costcentre.append('<option value="">-- Default Account --</option>');
    const importedCostcentre = this.model.get('costcentre');
    if (importedCostcentre.id && importedCostcentre.name) {
      this.ui.costcentre.append(
        '<option value=' + importedCostcentre.id + '>' + importedCostcentre.name + '</option>');
      this.ui.costcentre.val(importedCostcentre.id);
    }
  },

  setFirstMatchedContact() {
    const contactUi = this.ui.contact;
    const firstContact = contactUi.children()[0].value;
    contactUi.val(firstContact);
  },

  onChangeContact() {
    const contact = this.ui.contact.val();
    const model = this.getOption('import_model');
    const epayments = model.get('epayments');

    var epayment = epayments.findWhere({
      transaction: this.model.id
    });

    if (!contact) {
      epayments.remove(epayment);
    } else {
      if (!epayment) {
        epayment = new Backbone.Model({
          transaction: this.model.id
        });
        epayments.add(epayment);
      }
      epayment.set('contact', parseInt(this.ui.contact.val()));
      epayment.set('costcentre', parseInt(this.ui.costcentre.val()));
    }
  },

  _toLowerCase(model, field) {
    const value = model.get(field) || '';
    return value.toLowerCase();
  },

  _joinNames(person) {
    const lastName = this._toLowerCase(person, 'last_name');
    const firstName = this._toLowerCase(person, 'first_name');

    return `${lastName}, ${firstName}`;
  },

  _compareContacts(contact1, contact2) {
      const classesEqual = contact1.get('school_class') ==
        contact2.get('school_class');
      const yearsEqual = contact1.get('school_year') ==
        contact2.get('school_year');

      const forenamesEqual = this._toLowerCase(contact1, 'first_name') ===
        this._toLowerCase(contact2, 'first_name');
      const surnamesEqual = this._toLowerCase(contact1, 'last_name') ===
        this._toLowerCase(contact2, 'last_name');

      return forenamesEqual && surnamesEqual && classesEqual && yearsEqual;
  }
});


const TransactionList = Marionette.CompositeView.extend({
  template: require('../templates/table.html'),
  childView: Transaction,
  childViewContainer: 'tbody',
  tagName: 'table',
  className: 'datatable',

  childViewOptions(model, index) {
    return {
      collection: new ContactList(model.get('contacts')),
      className: index % 2 ? '' : 'alt',
      import_model: this.model,
      transaction_types: this.getOption('transaction_types'),
      queryModel: this.getOption('queryModel')
    };
  }
});

const Layout = Marionette.LayoutView.extend({
  template: require('../templates/list.html'),
  tagName: 'fieldset',
  className: 'block',

  regions: {
    table: '.table-hook',
    page: '.page-hook'
  },

  initialize() {
    this.queryModel = this.getOption('queryModel');
    this.transaction_types = new Backbone.Collection();
    this.transaction_types.url = this.getOption('links').transaction_types;
    this.transaction_types.fetch();
  },

  onShow() {
    const transaction = new TransactionList({
      collection: this.collection,
      model: this.model,
      links: this.getOption('links'),
      queryModel: this.getOption('queryModel'),
      transaction_types: this.transaction_types
    });
    const page = new PageView({ collection: this.collection });

    this.showChildView('table', transaction);
    this.showChildView('page', page);
  },

  onRequestSuccess() {
    this.collection.search_params = {
        description: this.queryModel.get('description'),
        transaction_type: this.queryModel.get('transaction_type')
    };

    const transactionView = this.getRegion('table').currentView;
    const pageView = this.getRegion('page').currentView;
    this.collection.fetch({
      success: () => {
        transactionView.render();
        pageView.render();
      }
    });
  }
});


module.exports = Layout;



// WEBPACK FOOTER //
// ./epayment_import/views/epayment.js